import script from "./SalesListsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesListsView.vue?vue&type=script&setup=true&lang=js"

import "./SalesListsView.vue?vue&type=style&index=0&id=7ba48ae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba48ae6"]])

export default __exports__